import n from"./math-trunc.js";var a=n,e=function(t){var r=+t;return r!==r||r===0?0:a(r)};export{e as default};
